import React from "react";
import IconSubject from "../assets/svg/icon-subject.svg";
import IconAge from "../assets/svg/icon-age.svg";

const ActivitiesShowcase: React.FC = () => {
  return (
    <div className="container">
      <div className="activities-showcase">
        <h2>Activities</h2>
        <p>
          Here are a cross section of some of the activities that kids can
          choose to interact with at the STEMCafe
        </p>

        <div className="activities-list">
          <div className="card-box">
            <h4>Color Mixing Lamp</h4>
            <p>
              How to produce any color with a lamp that uses light as an input.
            </p>
            <ul>
              <li>
                <img src={IconSubject} alt="" />
                Robotics
              </li>
              <li>
                <img src={IconAge} alt="" />
                10 - 18
              </li>
            </ul>
          </div>

          <div className="card-box">
            <h4>Automatic Light</h4>
            <p>
              How to build a sound-operated light that you can control with your
              voice.
            </p>
            <ul>
              <li>
                <img src={IconSubject} alt="" />
                Electricity
              </li>
              <li>
                <img src={IconAge} alt="" />
                8+
              </li>
            </ul>
          </div>

          <div className="card-box">
            <h4>Pulley hoist</h4>
            <p>
              How to change the direction of forces to be applied to your
              advantage.
            </p>
            <ul>
              <li>
                <img src={IconSubject} alt="" />
                Simple machines
              </li>
              <li>
                <img src={IconAge} alt="" />5 - 8
              </li>
            </ul>
          </div>

          <div className="card-box">
            <h4>Self-Driving Vehicle</h4>
            <p>
              How to build a circuit cruiser, a vehicle that gets around two DC
              motors.
            </p>
            <ul>
              <li>
                <img src={IconSubject} alt="" />
                Energy and Power
              </li>
              <li>
                <img src={IconAge} alt="" />5 - 8
              </li>
            </ul>
          </div>

          <div className="card-box">
            <h4>Touchy-Feel Lamp</h4>
            <p>How to program a lamp that responds to your touch.</p>
            <ul>
              <li>
                <img src={IconSubject} alt="" />
                Robotics
              </li>
              <li>
                <img src={IconAge} alt="" />
                10 - 18
              </li>
            </ul>
          </div>

          <div className="card-box">
            <h4>Water glass trick</h4>
            <p>How air can be a force</p>
            <ul>
              <li>
                <img src={IconSubject} alt="" />
                Air
              </li>
              <li>
                <img src={IconAge} alt="" />
                10 - 18
              </li>
            </ul>
          </div>

          <div className="card-box">
            <h4>Navigator</h4>
            <p>
              How to build a handheld device that allows you to navigate, even
              in the dark.
            </p>
            <ul>
              <li>
                <img src={IconSubject} alt="" />
                Air
              </li>
              <li>
                <img src={IconAge} alt="" />
                8+
              </li>
            </ul>
          </div>

          <div className="card-box">
            <h4>Art Machine</h4>
            <p>
              How to create a doodle with DC motors, and a pulse that dances,
              wiggles, and draws up a storm.
            </p>
            <ul>
              <li>
                <img src={IconSubject} alt="" />
                Power
              </li>
              <li>
                <img src={IconAge} alt="" />
                8+
              </li>
            </ul>
          </div>

          <div className="card-box">
            <h4>Castor Bot</h4>
            <p>
              How to build complex machines and control them with simple
              programs.
            </p>
            <ul>
              <li>
                <img src={IconSubject} alt="" />
                Robotics
              </li>
              <li>
                <img src={IconAge} alt="" />
                14+
              </li>
            </ul>
          </div>

          <div className="card-box">
            <h4>Spaceship interface</h4>
            <p>How to design a basic control panel.</p>
            <ul>
              <li>
                <img src={IconSubject} alt="" />
                Coding
              </li>
              <li>
                <img src={IconAge} alt="" />
                10 - 18
              </li>
            </ul>
          </div>

          <div className="card-box">
            <h4>Security Device</h4>
            <p>
              How to design a security alarm, with customized alarm for
              different places, and control of alarm speed.
            </p>
            <ul>
              <li>
                <img src={IconSubject} alt="" />
                Energy &amp; Power
              </li>
              <li>
                <img src={IconAge} alt="" />
                8+
              </li>
            </ul>
          </div>

          <div className="card-box book-card">
            <a
              href="https://stemcafe.typeform.com/to/Lacc0gDB"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h2>Book an activity</h2>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivitiesShowcase;
